// 数据 state
const state = {
  cutoutNum: {use: 0, num: 0}, // 抠图权益次数.2
  userMsg: {}, // 保存的用户信息
  userLevel: 0, // 保存的用户等级
  userLevelType: 0,
  userLevelName: '普通用户', // 保存的用户的等级名称
  userEquity: { // 用户的专属权益
    closeWaterMark: false, // 去除水印
    waterMark: false, // 自定义水印
    imgQuality: 480, // 画质
    AI: 1, // ai智能配音
    time: 210000, // 毫秒数
    uploadSound: 0, // 上传录音
    autoDraw: false, // 智能绘画
    Echart: false, // 图表判断
    isEchart: false, // 是否含有会员素材
    exclusive: false, // 会员素材专属判断
    exclusiveBtn: true // 会员素材的判断按钮
  },
  isVipSprites: { // vip素材
    data: [],
    type: true,
    dataLength: 0 // 判断数据长度
  },
  vipSceneEffects: [],
  userExtensions: 0, // 0-普通用户，1-父账号，2-子账号

  //"type":1, //成员类型，0：普通，2：设计师，4：管理员；6：创作者
  //"state": 2//成员状态，0：正常，1：邀请审核中，2：邀请拒绝，3：已退出 , 4:被剔除 5：已过期
  //为空时代表没有团队信息
  userTeamInfo: null,
  teamInfo: null,

  personVideo: 0,
  worksDraftNum: [], // 项目，作品，视频转换数
  freeVideoIds: [],
  soundCoupon: {
    num: 0
  },
  company: {
    name: '',
    phone: ''
  },
  brandColor: null, // 品牌颜色
  commercialRisk: [],
  toRemoveList: [],
  stamp: 0,
  isOld: true
};

// 获取数据 getters
const getters = {
  IsOldUser: state => state.isOld,
  cutoutNum: state => state.cutoutNum,
  CommercialRisk: state => state.commercialRisk,
  ToRemoveList: state => state.toRemoveList,
  /**
   *
   * level
   * 139 --- 企业高级Plus体验版
   * 140 --- 旧的企业高级Plus
   * 141 --- 企业臻享Plus
   * 142 --- 企业基础
   * 143 --- 企业高级
   * 144 --- 企业臻享
   * 145 --- 企业高级Plus
   *
   * levelType
   * 4 --- 企业臻享Plus
   * 3 --- 企业臻享 | 企业高级Plus
   * 2 --- 企业高级
   */
  UserMsg: state => state.userMsg, // 获取用户信息
  userInfo: state => state.userMsg,
  loginStatus: state => !!Object.keys(state.userMsg).length,

  /**
     * 是否为普通用户(非会员且非体验会员)
     * 另外如需判断是否为‘领取过临时会员的普通用户’,配合userMsg.scene1不为空判断
     */
  isPoor: ({ userMsg: ui }) => ui.level === 0 && ui.levelType === 0,

  // 是否为solo会员(正式)
  isSolo: ({ userMsg: ui }) => ui.level > 0 && ui.levelType === 0,

  // 是否为个人VIP体验版
  isTmpSolo: ({ userMsg: ui }) => ui.tmpLevel > 0 && ui.tmpLevelType === 0,

  // 是否为企业会员（正式版与体验版）
  isEenterprise: ({ userMsg: ui }) => ui.levelType > 0 || ui.tmpLevelType > 0,

  UserLevelInfo: ({userMsg: u}) => {
    const { level, levelType, tmpLevelType, tmpLevel, levelNewType, isCommercial } = u;
    const levelDefined = levelType != null && level != null;
    const tmpLevelDefined = tmpLevelType != null && tmpLevel != null;
    const isEp = levelDefined && levelType > 0 && level > 0;
    const isPerson = levelDefined && levelType === 0 && level > 0;
    const isStandard = levelDefined && levelType < 2 && levelNewType && levelNewType >= 22 && isCommercial; // 标准版
    // const isBasic = levelType === 0 && level === 0;
    const isTmpEp = tmpLevelDefined && tmpLevelType > 0 && tmpLevel > 0;
    const isTmpPerson = tmpLevelDefined && tmpLevelType === 0 && tmpLevel > 0;

    let levelName = 'basic';
    let trial = false;
    if (isPerson) levelName = 'person';
    if (isEp) levelName = 'enterprise';
    if (isStandard) levelName = 'standard';
    if (isTmpPerson) levelName = 'person', trial = true;
    if (isTmpEp) levelName = 'enterprise', trial = true;

    const dict = {
      'basic': 0,
      'person': 1,
      'standard' : 1,
      'enterprise': 2
    }
    return {
      levelName,
      levelCode: dict[levelName],
      trial
    };
  },

  IsEnjoymentLevel: ({userMsg}) => {
    const levelType = userMsg.levelType || 0;
    const flag = userMsg.isChartletCompanyLevel ? levelType >= 4 : levelType >= 3;
    return flag;
  },

  IsProLevelSystem: ({userMsg}) => {
    const { level, levelType, levelNewType = 0, chartletLevelNewType } = userMsg;
    const myType = chartletLevelNewType || levelNewType || 0;
    const isFree = myType === 0 && !levelType && !level;
    const isAnimation = levelNewType >= 17;
    const isDigitalHumans = [13, 14, 15, 16].includes(myType);
    return isAnimation || isDigitalHumans || isFree;
  },

  //用户类型：0管理员  1普通用户 2外部画师 3来画画师
  UserType: state => state.userType,

  /**
   * 0: 非会员，体验/临时会员; 1:企业会员标准版1季度; 2:企业会员标准版半年; 3:企业会员标准版1年; 4:企业会员标准版2年;
   * 5:企业会员高级版1季度; 6:企业会员高级版半年；7:企业会员高级版1年; 8:企业会员高级版2年; 9:企业会员至尊版1季度;
   * 10:企业会员至尊版半年; 11:企业会员至尊版1年；12：企业会员至尊版2年; 13：企业会员定制版; 25:个人VIP
   * 25: solo
   * 38 个人vip季度
   * 40 个人vip一年
   */
  UserLevel: state => state.userLevel, // 用户等级

  /**
   * 0: 非会员，个人VIP（UserLevel=25）
   * 1: 企业会员标准版
   * 2: 企业会员高级版，企业荣耀版，临时会员
   * 3: 企业会员至尊版，企业协作版
   * 9: 集团定制版
   * PS:UserLevelType与TempLevelType不会同时存在
   */
  UserLevelType: state => state.userLevelType,

  /**
   *
   * tmpLevelType用于临时会员区分等级类型：
   * 0-个人版
   * 1-企业标准版
   * 2-高级版(企业荣耀版)
   * 3-企业至尊版
   * 9-企业定制版
   */
  TmpLevelType: state => state.tmpLevelType,

  /**
   * 是否为正式vip账号，包含所有正式vip类型
   */
  isRealVip: state => state.userLevel && state.userLevel > 0,

  UserLevelName: state => state.userLevelName, // 用户的等级名称
  UserEquity: state => state.userEquity, // 用户的等级名称
  IsVipSprites: state => state.isVipSprites,
  UserExtensions: state => state.userExtensions,
  PersonVideoNumber: state => state.personVideo,
  WorksDraftNum: state => state.worksDraftNum, // 项目，作品，视频转换数
  FreeVideoIds: state => state.freeVideoIds,
  SoundCoupon: state => state.soundCoupon,
  Company: state => state.company,
  isPersonVip: state => {
    return state.userMsg.levelType === 0 && state.userMsg.level > 0
  },
  BrandColor: state => state.brandColor,
  UserTeamInfo: state => state.userTeamInfo,
  TeamInfo: state => state.teamInfo,
  DelStamp: state => state.stamp,
  VipSceneEffects: state => state.vipSceneEffects,
  IsDraftShareShown: (state, getters) => {
    getters.UserLevelInfo
    const levelCode = getters.UserLevelInfo.levelCode || 0;
    const trial = getters.UserLevelInfo.trial || false;
    return levelCode >= 2 && !trial;
  }
};

const getVipTypeText = ({ userMsg: ui }) => {
  let type = '未登录';
  switch (ui.level) {
    case 0:
      if (ui.tmpLevel > 0 && ui.tmpLevelType >= 0) {
        type = '临时会员';
      } else {
        type = '普通用户';
      }
      break;
    // case 25:
    // case 38:
    // case 40:
    //   type = '个人vip';
    //   break;
    default:
      const isEnterprise = ui.levelType > 0;
      const isSolo = ui.levelType === 0 && ui.level > 0;
      if (ui.tmpLevel > 0) {
        type = '临时会员';
      } else {
        if (isEnterprise) {
          type = '企业vip';
        } else if (isSolo) {
          type = '个人vip';
        }
      }
      break;
  }
  return type;
}

// 修改数据 mutations
const mutations = {
  setIsOldUser (state, v) {
    state.isOld = v;
  },
  setCommercialRisk (state, data = []) {
    state.commercialRisk = data.map(v => {
      let u = JSON.parse(JSON.stringify(v));
      // u.removed = false;
      return u;
    });
    //console.log("turbo: setCommercialRisk -> state.commercialRisk", state.commercialRisk);
  },
  setToRemoveList (state, data = []) {
    state.toRemoveList = data;
  },
  toggle_UserMsg (state, data) { // 修改用户信息
    const rawData = {...data};
    // 临时体验会员
    if (data.tmpLevelType != null && data.tmpLevelType > 1) {
      data.level = data.tmpLevel;
      data.levelType = data.tmpLevelType;
    }

    if (data.tmpLevelType != null && data.tmpLevelType === 0) {
      data.levelType = 0;
      data.level = data.tmpLevel;
    }

    let ver = data.guidance + '';
    let versionNumber = /^\d+(\.\d+)?(\.\d+)?$/.test(ver) ? ver : '360'; // 记录在服务器的版本号

    versionNumber = versionNumber.replace(/[.]/g, '') - 0;
    data.versionNumber = versionNumber;

    data.versionTOOL = 550; // 开发版本号

    // 新手引导
    data.versionUpdate = true;
    data.versionData = {
      data: [{
        url: '../../static/img/version.480.01.png'
      },
      {
        url: '../../static/img/version.480.02.png'
      },
      {
        url: '../../static/img/version.480.03.png'
      },
      {
        url: '../../static/img/version.480.04.png'
      }
      ],
      linkUrl: 'https://support.qq.com/products/408104/',
      updataMessage: '【v5.5.3版本】编辑器素材面板交互全新改版，素材分类展示更简洁，素材检索更高效，快速找到你的创作素材！点击查看。',
      btnData: {
        scenes: false,
        bg: false,
        text: false,
        characters: false,
        props: false,
        shapes: false,
        gif: false,
        sound: false,
        personal: false,
        userExtensions: false
      }
    };
    let vipTypeText = getVipTypeText({
      userMsg: rawData
    });
    sensors.registerPage({
      platform_type: 'web',
      vip_type: vipTypeText,
      is_login: !!data
    });
    sensors.login(data.id + '');
    sensors.quick('autoTrack');
    // UserMsg.type: 0--管理员；1--普通用户；2--外部画师；3--来画画师
    state.userMsg = data;
    state.userType = data.type;
    let isNumLevel = typeof + data.level === 'number' && !isNaN(+data.level);
    state.userLevel = isNumLevel ? data.level : 1;
    state.userLevelType = data.levelType;
    state.tmpLevelType = data.tmpLevelType;
    // state.isVipSprites.dataLength = 0;
    if (data.sonAccount) {
      state.userExtensions = 1;
    } else if (data.isSonAccount && data.isSonAccount == 1) {
      state.userExtensions = 2;
    } else {
      state.userExtensions = 0;
    }
    switch (data.levelType) {
      case 0:
        if (data.level > 0) {
          state.userLevelName = '个人VIP';
          state.userEquity = {
            closeWaterMark: data.nonWatermarkRemain, // 去除水印
            waterMark: 0, // 自定义水印
            imgQuality: state.userMsg.resolution ||  720, // 画质
            export720: 60,
            AI: data.kdxfTimes, // ai智能配音
            AIRemain: data.kdxfRemain,
            uploadSound: Infinity, // 上传录音
            // time: 180000, // 值为false时间长度不限制
            time: false,
            autoDraw: true, // 智能绘画
            Echart: false, // 图表判断
            isEchart: false, // 是否含有会员素材
            exclusive: true, // 会员素材专属判断
            exclusiveBtn: false, // 会员素材的判断按钮
            soloLimit: '25-echart', // 个人VIP限制使用的素材
            draftNum: 100, // 项目数量
            worksNum: 200, // 作品数量
            exportNum: 60, // 视频导出次数
            pptSize: 100, // ppt导入大小
            draftVideo: 3, // 单个作品中包含自定义上传的视频资源的数量
            noCustomCover: false,
            sceneNum: 20 // 场景数量限制
          };
        } else {
          state.userLevelName = '基础创作版';
          state.userEquity = {
            closeWaterMark: 0, // 去除水印
            waterMark: 0, // 自定义水印
            imgQuality: state.userMsg.resolution || 480, // 画质
            AI: 0, // ai智能配音
            uploadSound: Infinity, // 上传录音
            // time: 90000, // 值为false时间长度不限制
            time: 180000,
            autoDraw: false, // 智能绘画
            Echart: false, // 图表判断
            isEchart: false, // 是否含有会员素材
            exclusive: false, // 会员素材专属判断
            exclusiveBtn: true, // 会员素材的判断按钮
            soloLimit: '25-echart', // 个人VIP限制使用的素材
            draftNum: 10, // 项目数量
            worksNum: 20, // 作品数量
            exportNum: 10, // 视频导出次数
            pptSize: 10, // ppt导入大小
            draftVideo: 1, // 单个作品中包含自定义上传的视频资源的数量
            noCustomCover: true,
            sceneNum: 10 // 场景数量限制
          };
        }
        break;
      case 1:
        state.userLevelName = '企业普通版';
        state.userEquity = { // 用户的专属权益
          closeWaterMark: data.nonWatermarkRemain, // 去除水印
          waterMark: data.updateWatermarkRemain, // 自定义水印
          imgQuality: state.userMsg.resolution ||  720, // 画质
          export720: 60,
          AI: 0, // ai智能配音
          uploadSound: Infinity, // 上传录音
          time: false, // 值为false时间长度不限制
          autoDraw: false, // 智能绘画
          Echart: false, // 图表判断
          isEchart: false, // 是否含有会员素材
          exclusive: true, // 会员素材专属判断
          exclusiveBtn: false, // 会员素材的判断按钮
          draftNum: Infinity, // 项目数量
          worksNum: Infinity, // 作品数量
          exportNum: Infinity, // 视频导出次数
          pptSize: 200, // ppt导入大小
          draftVideo: Infinity // 单个作品中包含自定义上传的视频资源的数量
        };
        break;
      case 2:
        state.userLevelName = '企业荣耀版';
        state.userEquity = { // 用户的专属权益
          closeWaterMark: data.tmpLevelType ? data.nonWatermarkRemain : Infinity, // 去除水印
          waterMark: data.tmpLevelType ? data.updateWatermarkRemain : Infinity, // 自定义水印
          imgQuality: state.userMsg.resolution ||  720, // 画质
          export720: 60,
          AI: Infinity, // ai智能配音
          uploadSound: Infinity, // 上传录音
          time: false, // 值为false时间长度不限制
          autoDraw: true, // 智能绘画
          Echart: true, // 图表判断
          isEchart: false, // 是否含有会员素材
          exclusive: true, // 会员素材专属判断
          exclusiveBtn: false, // 会员素材的判断按钮
          draftNum: Infinity, // 项目数量
          worksNum: Infinity, // 作品数量
          exportNum: 60, // 视频导出次数
          pptSize: 200, // ppt导入大小
          draftVideo: Infinity // 单个作品中包含自定义上传的视频资源的数量
        };
        if (data.tmpLevelType && data.tmpLevelType > 1) {
          state.userEquity.closeWaterMark = 0;
          state.userEquity.waterMark = 0;
        }
        break;
      case 3:
      case 4:
        state.userLevelName = data.levelType === 4 ? '企业旗舰版' : '企业至尊版';
        state.userEquity = { // 用户的专属权益
          closeWaterMark: data.tmpLevelType ? data.nonWatermarkRemain : Infinity, // 去除水印
          waterMark: data.tmpLevelType ? data.updateWatermarkRemain : Infinity, // 自定义水印
          imgQuality: state.userMsg.resolution || 1080, // 画质
          AI: Infinity, // ai智能配音
          uploadSound: Infinity, // 上传录音
          time: false, // 值为false时间长度不限制
          autoDraw: true, // 智能绘画
          Echart: true, // 图表判断
          isEchart: false, // 是否含有会员素材
          exclusive: true, // 会员素材专属判断
          exclusiveBtn: false, // 会员素材的判断按钮
          draftNum: Infinity, // 项目数量
          worksNum: Infinity, // 作品数量
          exportNum: Infinity, // 视频导出次数
          pptSize: 200, // ppt导入大小
          draftVideo: Infinity // 单个作品中包含自定义上传的视频资源的数量
        };
        break;
      case 9:
        state.userLevelName = '集团定制版';
        state.userEquity = { // 用户的专属权益
          closeWaterMark: Infinity, // 去除水印
          waterMark: Infinity, // 自定义水印
          imgQuality: state.userMsg.resolution ||  1080, // 画质
          AI: Infinity, // ai智能配音
          uploadSound: Infinity, // 上传录音
          time: false, // 值为false时间长度不限制
          autoDraw: true, // 智能绘画
          Echart: true, // 图表判断
          isEchart: false, // 是否含有会员素材
          exclusive: true, // 会员素材专属判断
          exclusiveBtn: false, // 会员素材的判断按钮
          draftNum: Infinity, // 项目数量
          worksNum: Infinity, // 作品数量
          exportNum: Infinity, // 视频导出次数
          pptSize: 200, // ppt导入大小
          draftVideo: Infinity // 单个作品中包含自定义上传的视频资源的数量
        };
        break;
    }
    // 添加抠图权益
    state.cutoutNum = data.cutoutNum;
    // state.userEquity.cutoutNum.rest = data.cutoutNum.num - data.cutoutNum.use;
    if (state.userEquity.exclusive) {
      state.isVipSprites.type = true;
    }
  },
  toggle_UserMsgExclusive (state, data) { // 修改用户信息
    state.userEquity.exclusiveBtn = data.data;
  },
  toggle_UserMsgCutout (state, data) {
    state.cutoutNum = data;
  },
  push_vipSprites (state, data) {
    if (data.id == 'AllSound') {
      let dataArray = [];
      for (let i = 0; i < state.isVipSprites.data.length; i++) {
        if (state.isVipSprites.data[i].type !== 'ScenesSound') {
          dataArray.push(state.isVipSprites.data[i]);
        }
      }
      state.isVipSprites.data = dataArray;
    }
    for (let i = 0; i < state.isVipSprites.data.length; i++) {
      if (
        state.isVipSprites.data[i].id == data.id
      ) {
        state.isVipSprites.data.splice(i, 1);
        break;
      }
    }

    if (data.action) {
      let filtered = (state.isVipSprites.data || []).filter(v => v.id === 'uploadVideoNUM') || [];
      state.isVipSprites.data = [...data.data, ...filtered];
    } else {
      // state.isVipSprites.data.push({
      //   id         : data.id,
      //   type       : data.type,
      //   scenesId   : data.scenesId,
      //   resourceId : data.resourceId
      // });
      if (Array.isArray(data.data)) {
        data.data.forEach(v => {
          if (v.type === 'RichText') {
            state.isVipSprites.data.push(v);
            return;
          }
          let f = state.isVipSprites.data.find(s => s.id === v.id);
          !f && state.isVipSprites.data.push(v);
        });
      } else {
        state.isVipSprites.data.push(data);
      }
    }
    if (state.isVipSprites.data.length) {
      if (state.userEquity.exclusive) {
        state.isVipSprites.type = true;
      } else {
        state.isVipSprites.type = false;
      }
    } else {
      state.isVipSprites.type = true;
    }
    state.userEquity.isEchart = false;
    for (let i = 0; i < state.isVipSprites.data.length; i++) {
      if (state.isVipSprites.data[i].type === 'Chart' && !state.userEquity.Echart) {
        state.userEquity.isEchart = true;
        break;
      }
    }
    // state.isVipSprites.data = Array.from(new Set(state.isVipSprites.data));
    // state.isVipSprites.data = [...state.isVipSprites.data];
    state.isVipSprites.dataLength = state.isVipSprites.data.length;
  },
  delCommercialRisk (state, data) {
    //console.log("turbo: delCommercialRisk -> data", data);
    for (let i = 0; i < state.commercialRisk.length; i++) {
      let risk = state.commercialRisk[i];
      //console.log("turbo: delCommercialRisk -> risk", risk);
      if (
        risk.id == data.id
      ) {
        state.commercialRisk.splice(i, 1);
        break;
      }
    }
  },
  del_vipSprites (state, data) {
    let bl = state.commercialRisk.length;
    state.commercialRisk = state.commercialRisk.filter(v => v.id !== data.id);
    let al = state.commercialRisk.length;
    if (al < bl) {
      state.stamp = Date.now();
    }
    // for (let i = 0; i < state.commercialRisk.length; i++) {
    //   let risk = state.commercialRisk[i];
    //   if (
    //     risk.id == data.id
    //   ) {
    //     state.commercialRisk.splice(i, 1);
    //     break;
    //   }
    // }
    state.toRemoveList = state.toRemoveList.filter(v => v.id !== data.id);
    // for (let i = 0; i < state.isVipSprites.data.length; i++) {
    //   if (state.isVipSprites.data[i].id == data.id) {
    //     state.isVipSprites.data.splice(i, 1);
    //     break;
    //   }
    // }
    state.isVipSprites.data = state.isVipSprites.data.filter(v => v.id !== data.id);
    if (state.isVipSprites.data.length) {
      if (state.userEquity.exclusive) {
        state.isVipSprites.type = true;
      } else {
        state.isVipSprites.type = false;
      }
    } else {
      state.isVipSprites.type = true;
    }
    let isEchart = false;
    for (let i = 0; i < state.isVipSprites.data.length; i++) {
      if (state.isVipSprites.data[i].type === 'Chart' && !state.userEquity.Echart) {
        isEchart = true;
        break;
      }
    }
    if (isEchart) {
      state.userEquity.isEchart = true;
    } else {
      state.userEquity.isEchart = false;
    }
    state.isVipSprites.dataLength = state.isVipSprites.data.length;
  },
  rm_scenesVipSprites (state, data) {
    let dataLength = state.isVipSprites.data.length,
      dataList = [];
    for (let i = 0; i < dataLength; i++) {
      if (state.isVipSprites.data[i].scenesId !== data.id) {
        dataList.push(
          state.isVipSprites.data[i]
        );
      }
    }
    state.isVipSprites.data = dataList;
    if (state.isVipSprites.data.length) {
      if (state.userEquity.exclusive) {
        state.isVipSprites.type = true;
      } else {
        state.isVipSprites.type = false;
      }
    } else {
      state.isVipSprites.type = true;
    }
    let isEchart = false;
    for (let i = 0; i < state.isVipSprites.data.length; i++) {
      if (state.isVipSprites.data[i].type === 'Chart') {
        isEchart = true;
        break;
      }
    }
    if (isEchart) {
      state.userEquity.isEchart = true;
    } else {
      state.userEquity.isEchart = false;
    }
    state.isVipSprites.dataLength = state.isVipSprites.data.length;
  },
  countPersonVideo (state, data) {
    state.personVideo = data;
  },
  push_worksDraftNum (state, data) {
    let judgePush = true;
    for (let i = 0; i < state.worksDraftNum.length; i++) {
      let item = state.worksDraftNum[i];
      if (item.type == data.type) {
        judgePush = false;
      }
    }
    if (judgePush) {
      state.worksDraftNum.push(data);
    }
  },
  save_freeVideoIds (state, data) {
    state.freeVideoIds = data;
  },
  save_soundCoupon (state, data) {
    state.soundCoupon = {
      ...state.soundCoupon,
      ...data
    }
  },
  save_company (state, data) {
    state.company = {
      ...state.company,
      ...data
    }
  },
  save_brandColor (state, data) {
    state.brandColor = data
  },
  save_userTeamInfo (state, data) {
    state.userTeamInfo = data;
  },
  save_teamInfo (state, data) {
    state.teamInfo = data;
  },
  setVipSceneEffects (state, data) {
    state.vipSceneEffects = data;
  }
};

const actions = {
  showServiceChat (context) {
    const rawData = context.state.userMsg;
    window._MEIQIA('metadata', {
      "昵称": rawData.nickname,
      "用户id": rawData.id || "",
      "注册时间": yymmddhhmmss(rawData.regtime * 1000),
      "会员开通时间": yymmddhhmmss(rawData.startDay * 1000),
      "会员到期时间": yymmddhhmmss(rawData.endDay * 1000),
      "会员等级": rawData.levelName,
    });
    _MEIQIA('showPanel');
  }
}

function pad2 (n) { return n < 10 ? '0' + n : n }

/**
 * Return padded date string
 * @return {string}
 */
function yymmddhhmmss (ms) {
  const date = new Date(ms)
  return date.getFullYear().toString() + '-' +
    pad2(date.getMonth() + 1) + '-' +
    pad2(date.getDate()) + ' ' +
    pad2(date.getHours()) + ':' +
    pad2(date.getMinutes()) + ':' +
    pad2(date.getSeconds())
}

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js